import { useEffect, useState } from "react";
import styles from "./WaitingBottomBar.module.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

const WaitingBottomBar: React.FC = () => {
    const startingPinNumber = 0;
    const [numberOfPins, setNumberOfPins] = useState(startingPinNumber);
    const isMobile: boolean = useSelector((state: RootState) => state.client.isMobile);
    const isWaiting: boolean = useSelector((state: RootState) => state.app.isWaiting);
    const pinImage = require("./elements/waitingPin.png");
    const [pins, setPins] = useState<JSX.Element[]>([]);

    useEffect(() => {
        let interval: NodeJS.Timeout | undefined;

        if (!isWaiting) {
            interval = setInterval(() => {
                setNumberOfPins((prevPins) => (prevPins < 3 ? prevPins + 1 : startingPinNumber));
            }, 400);
        }

        return () => {
            if (interval) {
                clearInterval(interval);
                setNumberOfPins(startingPinNumber);
            }
        };
    }, [isWaiting]);

    useEffect(() => {
        setPins(() => {
            const pinList = [];
            for (let i = 0; i < numberOfPins; i++) {
                pinList.push(
                    <img
                        className={isMobile ? styles.pinImageMobile : styles.pinImageDesktop}
                        key={i}
                        alt="p"
                        src={pinImage}
                    />,
                );
            }
            return pinList;
        });
    }, [numberOfPins]);

    return (
        <div>
            {!isWaiting && (
                <div className={isMobile ? styles.barMobile : styles.barDesktop}>
                    <div className={isMobile ? styles.centerMobile : styles.centerDesktop}>{pins}</div>
                </div>
            )}
        </div>
    );
};

export default WaitingBottomBar;
